import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bool, func, number } from "prop-types";
import { Link, useLocation } from "react-router-dom";
import Button from "pages/_components/Button";
import GridTable from "pages/_components/GridTable/GridTable";
import ProductList from "pages/_components/product/List";
import Drawer from "pages/_components/Drawer/Drawer";
import { actions as ThirdPartiesActions } from "reducers/thirdPayment";
import { thirdPaymentOptions } from "util/thirdPayment";
import { isEmpty } from "lodash";
import { push } from "connected-react-router";
import EmptyScreenAlert from "pages/_components/EmptyScreenAlert/EmptyScreenAlert";
import Loader from "pages/_components/Loader";
import TitleColumns from "./components/TitleColumns";
import VendorsLotPaymentsItem from "./components/ItemRow";
import EmitedSideBarForm from "../_components/SideBarForm";
import FilterTags from "../_components/FilterTags";

const LotPaymentsTable = ({ isDesktop, fetchMoreTransactions, positionTab }) => {
    const [openSidebar, setOpenSidebar] = useState(false);
    const [id, setId] = useState("");
    const [runEffect, setRunEffect] = useState(false);
    const { state = { tab: 0 } } = useLocation();
    const [actionDrawer, setActionDrawer] = useState({ showDrawer: false, contentDrawer: null });
    const { fetching, latestTotalPages, latestPageNumber, transactionLinesStatus, filterThirdParties } = useSelector(
        (_state) => _state.thirdPayment,
    );
    const { transaction } = useSelector((_state) => _state.thirdPayment);
    const {
        user: { userId },
    } = useSelector((_state) => _state.session);

    useEffect(() => {
        setRunEffect(false);
    }, []);

    const hasMoreData = latestPageNumber < latestTotalPages;

    const dispatch = useDispatch();

    const openSideBarFilters = () => {
        setOpenSidebar(true);
    };

    const handleCloseActionDrawer = () => {
        setActionDrawer({ showDrawer: false, contentDrawer: null, title: "" });
    };

    const handleAnulate = useCallback((idLotPayment) => {
        setRunEffect(true);
        setId(idLotPayment);
        dispatch(ThirdPartiesActions.getTransaction(idLotPayment, true));
    }, []);

    useEffect(() => {
        if (positionTab !== state.tab) {
            return;
        }
        const data = {
            dateFrom: null,
            dateTo: null,
            amountFrom: "",
            amountTo: "",
            pageNumber: 1,
            status: "",
            latestPageNumber: 1,
            latestTotalPages: 1,
            typePayment: state?.tab === 0 ? "PP" : "PH",
        };
        dispatch(ThirdPartiesActions.setThirdPartiesFilters({ ...data }));
        dispatch(ThirdPartiesActions.loadListThirdRequest({ ...data }));
    }, [state.tab]);
    useEffect(() => {
        if (!isEmpty(transaction)) {
            dispatch(
                ThirdPartiesActions.summaryThirdPay({
                    ...transaction,
                    idTransaction: id,
                    cancelTransaction: true,
                    userId,
                }),
            );
            if (runEffect) {
                dispatch(push(`/lotPayments/newPayment/confirm`));
            }
        }
    }, [transaction]);

    const handleData = () => {
        let data;
        if (!fetching) {
            if (transactionLinesStatus?.length) {
                data = (
                    <>
                        <ProductList
                            fetchingWithPreviousData
                            fetching={fetching}
                            items={transactionLinesStatus || []}
                            noDataText="global.no.results"
                            noFiltersDataText="debin.global.no.results"
                            renderItem={(item) => (
                                <GridTable.Container
                                    key={`providers-ThirdPayment-item-${item?.transaction?.idTransaction}`}
                                    renderAs={Link}
                                    to={`/ThirdPayment/providers/detail/${item?.transaction?.idTransaction}`}>
                                    <VendorsLotPaymentsItem
                                        key={`transaction-${item?.transaction?.idTransaction}`}
                                        receibedThirdPayment={item}
                                        setDrawer={setActionDrawer}
                                        onAnulate={handleAnulate}
                                        isDesktop={isDesktop}
                                        withOptions={false}
                                    />
                                </GridTable.Container>
                            )}>
                            {(listItem) => (
                                <GridTable className="lotpayments-table tablelist underlined">
                                    <GridTable.Header>
                                        <GridTable.Container>
                                            <TitleColumns />
                                        </GridTable.Container>
                                    </GridTable.Header>
                                    <GridTable.Body>{listItem}</GridTable.Body>
                                    {hasMoreData && (
                                        <Button
                                            bsStyle="link"
                                            onClick={() => fetchMoreTransactions(latestPageNumber, filterThirdParties)}
                                            image="images/figma/icon/arrow.svg"
                                            label="global.showMore"
                                        />
                                    )}
                                </GridTable>
                            )}
                        </ProductList>
                    </>
                );
            } else {
                data = (
                    <EmptyScreenAlert
                        showLoader={fetching}
                        message={
                            positionTab === 0
                                ? "thirdPayment.service.noData.providers"
                                : "thirdPayment.service.noData.assets"
                        }
                    />
                );
            }
        } else {
            data = <Loader />;
        }
        return data;
    };

    return (
        <div className="container">
            <FilterTags
                openSideBarFilters={openSideBarFilters}
                optionThirdParty={thirdPaymentOptions[0]}
                positionTab={positionTab}
            />
            {handleData()}
            <Drawer openSidebar={openSidebar} toggleSidebar={setOpenSidebar}>
                <EmitedSideBarForm closeSidebar={setOpenSidebar} positionTab={positionTab} />
            </Drawer>
            <Drawer openSidebar={actionDrawer.showDrawer} onClose={handleCloseActionDrawer}>
                {actionDrawer.contentDrawer}
            </Drawer>
        </div>
    );
};

LotPaymentsTable.propTypes = {
    isDesktop: bool.isRequired,
    fetchMoreTransactions: func.isRequired,
    positionTab: number.isRequired,
};

export default LotPaymentsTable;
